import { forwardRef, Fragment } from "react";
import Box from "@mui/material/Box";
import classes from "./PrintContent.module.css";
import Typography from "@mui/material/Typography";
import {
  DateField,
  NumberField,
  RecordContextProvider,
  usePermissions,
} from "react-admin";
import splitArrayToChunks from "../../utils/splitArrayToChunks";

const PrintContent = forwardRef((props, ref) => {
  // eslint-disable-line max-len
  const { permissions, isLoading } = usePermissions();

  let totalMutation = 0;
  return isLoading ? null : (
    <Box
      component="div"
      sx={{
        display: "none",
      }}
    >
      <Box
        ref={ref}
        sx={{
          fontSize: "12px",
          py: 2,
          px: 2,
          display: "flex",
          flexDirection: "column",
          height: "139.7mm",
          minHeight: "139.7mm",
          boxSizing: "border-box",
        }}
      >
        <style type="text/css" media="print">
          {`@page {
              width: 215.9mm;
              height: 139.7mm;
              size: 8.5in 5.5in portrait;
              margin: 0;
            }
            html, body {
              width: 215.9mm;
              height: 100%;
            }
            .page-break {
              display: block;
              page-break-after: always;
            }
            .big-back::before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-image: url('/atena-tiles.png');
              background-repeat: no-repeat;
              background-position: 50% 28%;
              background-size: 20% auto;
              opacity: 0.2;
              z-index: -1;
            }
          `}
        </style>
        {splitArrayToChunks(props.record.journal_items, 7).map(
          (arr, i, ori) => {
            return (
              <Fragment key={i}>
                <Box
                  className="big-back"
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    ...(i > 0 ? { mt: 2 } : {}),
                  }}
                >
                  <Box>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          mb: 0.5,
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }}
                      >
                        {props.record.company.alias}
                      </Typography>
                      <div style={{ fontSize: "10px" }}>
                        {i + 1}/{ori.length}
                      </div>
                    </div>
                    <Typography
                      sx={{
                        textAlign: "center",
                        fontWeight: "bold",
                        textDecoration: "underline",
                        fontSize: "18px",
                        mt: 0,
                        mb: 0.5,
                        lineHeight: 1,
                        fontFamily: "Arial, Helvetica, sans-serif",
                      }}
                    >
                      BUKTI PENGELUARAN KAS/BANK
                    </Typography>
                    <Box
                      component="table"
                      className={classes.headerSj}
                      sx={{
                        "& th.no-wrap": {
                          whiteSpace: "nowrap",
                        },
                        "& th": {
                          verticalAlign: "top",
                        },
                      }}
                    >
                      <thead>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th style={{ width: "80%" }}></th>
                          <th className="no-wrap">Tanggal</th>
                          <th>:</th>
                          <th className="no-wrap">
                            <RecordContextProvider value={props.record}>
                              <DateField
                                source="date"
                                sx={{
                                  fontFamily: "Arial, Helvetica, sans-serif",
                                  fontWeight: "normal",
                                  fontSize: "12px",
                                }}
                                options={{
                                  year: "numeric",
                                  month: "short",
                                  day: "2-digit",
                                }}
                              ></DateField>
                            </RecordContextProvider>
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th style={{ width: "80%" }}></th>
                          <th className="no-wrap">No. Voucher</th>
                          <th>:</th>
                          <th
                            className="no-wrap"
                            style={{
                              textTransform: "uppercase",
                              fontWeight: "normal",
                            }}
                          >
                            {props.record.code}
                          </th>
                        </tr>
                        <tr>
                          <th style={{ height: "6px" }}></th>
                        </tr>
                        <tr>
                          <th className="no-wrap" style={{ marginTop: "6px" }}>
                            Keterangan
                          </th>
                          <th>:</th>
                          <th colSpan={4}>
                            <span
                              style={{
                                textTransform: "uppercase",
                                fontWeight: "normal",
                              }}
                            >
                              {props.record.note}
                            </span>
                          </th>
                        </tr>
                      </thead>
                    </Box>
                    <Typography
                      sx={{
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "13px",
                        mt: 1,
                        mb: 1,
                        fontFamily: "Arial, Helvetica, sans-serif",
                      }}
                    >
                      Detail Jurnal
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, minHeight: 0 }}>
                    <Box
                      component="table"
                      className={classes.tableSj}
                      sx={{
                        width: "100%",
                        // height: "100%",
                        "& th.no-wrap": {
                          whiteSpace: "nowrap",
                        },
                        "& th": {
                          verticalAlign: "top",
                        },
                      }}
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "12%" }}>Acc. Code</th>
                          <th style={{ width: "50%" }}>Account Name</th>
                          <th style={{ width: "19%", textAlign: "right" }}>
                            Debits
                          </th>
                          <th style={{ width: "19%", textAlign: "right" }}>
                            Credits
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {arr.map((obj, idx) => {
                          totalMutation += obj.debit * 1;
                          return (
                            <tr key={obj.id}>
                              <td
                                className={classes.noWrap}
                                style={{
                                  borderTop: "none",
                                  borderBottom: "none",
                                  paddingTop: "0",
                                  paddingBottom: "0",
                                  height: "1px",
                                  margin: 0,
                                }}
                              >
                                {obj.chart_of_account.code}
                              </td>
                              <td
                                style={{
                                  borderTop: "none",
                                  borderBottom: "none",
                                  paddingTop: "0",
                                  paddingBottom: "0",
                                  height: "1px",
                                  margin: 0,
                                }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                  }}
                                >
                                  {obj.chart_of_account.name}
                                </p>
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  borderTop: "none",
                                  borderBottom: "none",
                                  paddingTop: "0",
                                  paddingBottom: "0",
                                  height: "1px",
                                  margin: 0,
                                }}
                              >
                                <RecordContextProvider value={obj}>
                                  <NumberField
                                    source="debit"
                                    sx={{
                                      fontFamily: "Arial, Helvetica, sans-serif",
                                      fontWeight: "inherit",
                                      fontSize: "12px",
                                    }}
                                  ></NumberField>
                                </RecordContextProvider>
                              </td>
                              <td
                                style={{
                                  textAlign: "right",
                                  borderTop: "none",
                                  borderBottom: "none",
                                  paddingTop: "0",
                                  paddingBottom: "0",
                                  height: "1px",
                                  margin: 0,
                                }}
                              >
                                <RecordContextProvider value={obj}>
                                  <NumberField
                                    source="credit"
                                    sx={{
                                      fontFamily: "Arial, Helvetica, sans-serif",
                                      fontWeight: "inherit",
                                      fontSize: "12px",
                                    }}
                                  ></NumberField>
                                </RecordContextProvider>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            colSpan={3}
                            style={{
                              textAlign: "right",
                              verticalAlign: "baseline",
                              fontWeight: "bold",
                              borderLeft: "none",
                              borderRight: "none",
                              borderBottom: "none",
                            }}
                          >
                            <RecordContextProvider value={props.record}>
                              <NumberField
                                source="total"
                                sx={{
                                  fontFamily: "Arial, Helvetica, sans-serif",
                                  fontWeight: "inherit",
                                  fontSize: "12px",
                                }}
                              ></NumberField>
                            </RecordContextProvider>
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              verticalAlign: "baseline",
                              fontWeight: "bold",
                              borderLeft: "none",
                              borderRight: "none",
                              borderBottom: "none",
                            }}
                          >
                            <RecordContextProvider value={props.record}>
                              <NumberField
                                source="total"
                                sx={{
                                  fontFamily: "Arial, Helvetica, sans-serif",
                                  fontWeight: "inherit",
                                  fontSize: "12px",
                                }}
                              ></NumberField>
                            </RecordContextProvider>
                          </td>
                        </tr>
                      </tfoot>
                    </Box>
                  </Box>
                  <Typography
                    sx={{
                      mt: 1,
                      mb: 1.5,
                      fontSize: "10px",
                      textTransform: "capitalize",
                      fontFamily: "Arial, Helvetica, sans-serif",
                    }}
                  >
                    {"Terbilang: " + props.record.total_in_words + " Rupiah"}
                  </Typography>
                  {permissions.accounting ? (
                    <Box
                      component="table"
                      className={classes.tableACC}
                      sx={{
                        width: "100%",
                        mt: 2,
                        fontFamily: "Arial, Helvetica, sans-serif",
                      }}
                    >
                      <thead>
                        <tr>
                          <th colSpan={2}>Disetujui Oleh</th>
                          <th colSpan={2}>Diketahui Oleh</th>
                          <th>Dibayar Oleh</th>
                          <th rowSpan={2}>Penerima</th>
                        </tr>
                        <tr>
                          <th style={{ width: "16.67%" }}>COMMISSIONER</th>
                          <th style={{ width: "16.67%" }}>DIRECTOR</th>
                          <th style={{ width: "16.67%" }}>MANAGER</th>
                          <th style={{ width: "16.67%" }}>FINANCE</th>
                          <th style={{ width: "16.67%" }}>ACCOUNTING</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ height: "60px" }}></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </Box>
                  ) : (
                    <Box
                      component="table"
                      className={classes.tableACC}
                      sx={{
                        width: "100%",
                        mt: 2,
                        fontFamily: "Arial, Helvetica, sans-serif",
                      }}
                    >
                      <thead>
                        <tr>
                          <th colSpan={2}>Mengetahui</th>
                          <th colSpan={2}>Pelaksana</th>
                          <th>Penerima</th>
                        </tr>
                        <tr>
                          <th style={{ width: "20%" }}>KEPALA REGIONAL</th>
                          <th style={{ width: "20%" }}>KEPALA DEPO</th>
                          <th style={{ width: "20%" }}>AKUNTING</th>
                          <th style={{ width: "20%" }}>FINANCE</th>
                          <th style={{ width: "20%" }}>PENERIMA</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ height: "60px" }}></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </Box>
                  )}
                </Box>
                <div className="page-break" />
              </Fragment>
            );
          }
        )}
      </Box>
    </Box>
  );
});
export default PrintContent;
